module.exports = __webpack_public_path__ + "static/media/repuestosx4.87f0851b.jpg";